import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private showLoaderSubject = new Subject<boolean>();
  showLoader$ = this.showLoaderSubject.asObservable();
  public show: boolean = false; // Temporarily disabled
  showLoader() {
    this.showLoaderSubject.next(true);
  }

  hideLoader() {
    this.showLoaderSubject.next(false);
  }
}
